import React from 'react';

export const AuditDownloadIcon = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className={className}
      d="M9.26983 6.19604H11.5555L7.55554 10.3137L3.55554 6.19604H5.84126V2.66663H9.26983V6.19604ZM3.55554 12.666V11.4895H11.5555V12.666H3.55554Z"
    />
  </svg>
);
